import { pick } from 'lodash';

export default {
    computed: {
        allCardData() {
            return {
                yearlyFeeYear1: {
                    title: this.$translate('yearly_fee_year_1'),
                    value: this.$format.currency(this.model.firstYearCost) || this.model.yearlyCostString,
                    tooltipText: this.$translate('tooltip_yearly_fee_year_1')
                },
                yearlyFeeFromYear2: {
                    title: this.$translate('yearly_fee_from_year_2'),
                    value: this.model.yearlyCostString,
                    tooltipText: this.$translate('tooltip_yearly_fee_from_year_2')
                },
                interest: {
                    title: this.$translate('rate', 'Ränta'),
                    value: this.model.interestString,
                    tooltipText: this.$translate('tooltip_interest_rate')
                },
                effectiveInterest: {
                    title: this.$translate('effective_rate', 'Effektiv ränta'),
                    value: this.model.effectiveInterestString,
                    tooltipText: this.$translate('tooltip_effective_interest_rate')
                },
                paymentCostsInland: {
                    title: 'Inland',
                    value: this.$format.percentage(0, 0),
                    tooltipText: this.$translate('tooltip_payment_costs_inland')
                },
                paymentCostsEurozone: {
                    title: 'Eurozone',
                    value: this.$format.percentage(0, 0),
                    tooltipText: this.$translate('tooltip_payment_costs_eurozone')
                },
                paymentCostsWorldwide: {
                    title: 'Fremdwährung weltweit',
                    value: this.model.getCurrencyExchangeFeeString(),
                    tooltipText: this.$translate('tooltip_payment_costs_worldwide')
                },
                withdrawalCostsInland: {
                    title: 'Inland',
                    value: this.model.getWithdrawalFeeString(),
                    tooltipText: this.$translate('tooltip_withdrawal_costs_inland')
                },
                withdrawalCostsEurozone: {
                    title: 'Eurozone',
                    value: this.model.getWithdrawalFeeString(),
                    tooltipText: this.$translate('tooltip_withdrawal_costs_eurozone')
                },
                withdrawalCostsWorldwide: {
                    title: 'Fremdwährung weltweit',
                    value: (this.model.withdrawalFeePercentage === 0 && this.model.withdrawalFeeFixed === 0) ?
                        this.model.getCurrencyExchangeFeeString() : 
                        this.model.getWithdrawalFeeString(),
                    tooltipText: this.$translate('tooltip_withdrawal_costs_worldwide')
                },
                yearlyFee: {
                    title: this.$translate('yearly_fee', 'Årsavgift'),
                    value: this.model.yearlyCostHtml,
                    tooltipText: this.$translate('tooltip_yearly_fee'),
                    isYearlyFee: true

                },
                interestFreeDays: {
                    title: this.$translate('rate_free_days', 'Räntefria dagar'),
                    value: this.model.getInterestFreeDaysString(this.$translate('core_models_rate_free_days', '{days} dagar')),
                    tooltipText: this.$translate('tooltip_interest_free_days')
                },
                maxCredit: {
                    title: this.$translate('max_credit', 'Maxkredit'),
                    value: this.model.getMaxCreditString(this.$translate('no_max_credit', 'Ingen kreditgräns')),
                    tooltipText: this.$translate('tooltip_max_credit')
                },
                currencyExchangeFee: {
                    title: this.$translate('currency_exchange_fee', 'Valutapåslag'),
                    value: this.model.getCurrencyExchangeFeeString(),
                    tooltipText: this.$translate('tooltip_currency_exchange_fee')
                },
                withdrawalFee: {
                    title: this.$translate('withdrawal_fee', 'Uttagsavgift'),
                    value: this.model.getWithdrawalFeeString(),
                    tooltipText: this.$translate('tooltip_withdrawal_fee')
                },
                invoiceFee: {
                    title: this.$translate('invoice_fee', 'Aviavgift'),
                    value: this.model.getAviFeeString(this.$translate('core_models_avi_fee', '{paperInvoiceFee} ({eInvoiceFee} e-faktura)')),
                    tooltipText: this.$translate('tooltip_invoice_fee')
                },
                minAmountToPay: {
                    title: this.$translate('min_amount_to_pay', 'Minsta belopp att betala'),
                    value: this.model.getInvoiceMinToPayString(),
                    tooltipText: this.$translate('tooltip_min_amount_to_pay')
                },
                hasFreeExtraCard: {
                    title: this.$translate('extra_card', 'Gratis extrakort'),
                    value: this.$formatBoolean(this.model.hasFreeExtraCard),
                    tooltipText: this.$translate('tooltip_extra_card')
                },
                applePay: { 
                    title: 'Apple Pay',
                    iconClass: this.$formatBooleanIcon(this.model.hasApplePay),
                    tooltipText: this.$translate('tooltip_apple_pay')
                },
                googlePay: {
                    title: 'Google Pay',
                    iconClass: this.$formatBooleanIcon(this.model.hasGooglePay),
                    tooltipText: this.$translate('tooltip_google_pay')
                },
                samsungPay: {
                    title: 'Samsung Pay',
                    iconClass: this.$formatBooleanIcon(this.model.hasSamsungPay),
                    tooltipText: this.$translate('tooltip_samsung_pay')
                },
                cardType: {
                    title: this.$translate('card_type', 'Korttyp'),
                    value: this.model.isDebit 
                        ? this.$translate('prepaid_card', 'Prepaid') 
                        : this.model.isAggregator 
                            ? this.$translate('aggregator_card', 'Prepaid') 
                            : this.$translate('credit_card', 'Kreditkort'),
                    tooltipText: this.$translate('tooltip_card_type')
                },
                ageLimit: {
                    title: this.$translate('age_limit', 'Åldersgräns'),
                    value: this.model.minAge,
                    tooltipText: this.$translate('tooltip_age_limit')
                },
                paymentLogo: {
                    title: this.$translate('payment_network', 'Betalnätverk'),
                    value: this.paymentLogo,
                    tooltipText: this.$translate('tooltip_payment_network'),
                    disabled: Boolean(!this.paymentLogo)
                }
            };
        },
        paymentLogo() {
            return this.$getPaymentLogoHtml(this.model.paymentNetwork, 40);
        }
    },
    methods: {
        getCardData(keys) {
            let cardData = pick(this.allCardData, keys);
            return Object.values(cardData).filter(item => !item.disabled);
        }
    }
};